// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { generalConfigSelector, sessionConfigSelector, debugConfigSelector } from '../../../../../selectors/configSelectors';
import { headingSelector } from '../../../../../selectors/targetSelectors';
import { makeCarEntityAutoSelector, makeCarEntitySystemSelector, makeCarEntityDeviceSelector } from '../../../../../selectors/carSelectors';
import targetActions from '../../../../../actions/targetActions';
import { isActive } from '../../../../../utils/targetUtils';
import Car from '../Car';
import type { Props } from '../Car';

type OwnProps = $ReadOnly<{|
    icao: string,
    dataSource: 'auto' | 'system' | 'device',
    debug?: boolean
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    const generalConfig = generalConfigSelector(state);
    const sessionConfig = sessionConfigSelector(state);
    const debugConfig = debugConfigSelector(state);

    let carBufer;
    if(props.dataSource === 'auto') {
        carBufer = makeCarEntityAutoSelector(props.icao)(state);
    }
    else if(props.dataSource === 'system') {
        carBufer = makeCarEntitySystemSelector(props.icao)(state);
    }
    else if(props.dataSource === 'device') {
        carBufer = makeCarEntityDeviceSelector(props.icao)(state);
    }
    else {
        throw new Error(`Unknown dataSource "${props.dataSource}"`);
    }

    const car = carBufer && carBufer[0];

    return {
        carBuffer: carBufer,
        heading: headingSelector(props.icao, carBufer)(state),
        isActive: Boolean(car && isActive(car.TimeOfTrackInformation, sessionConfig)),
        showLabel: Boolean(generalConfig.showLabels && generalConfig.labelType === 'draggable'),
        showTrails: generalConfig.showTrails,
        showDisconnected: debugConfig.showDisconnected
    };
};

const mapDispatchToProps = {
    selectTarget: targetActions.selectThunk
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Car);